import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const tableCell: NodeRenderer = (node, children) => (
  <td className="border-b border-solid border-[rgb(224,224,224)] p-4 text-085 leading-alternate">
    {children}
  </td>
)
